import Axios from 'axios';
import { getEndpointURL } from './config';
Axios.defaults.withCredentials = true;

const endpointURL = getEndpointURL();
const headers = { 'Content-Type': 'application/json; charset=utf-8' };

const GetSchedules = async (searchSchedule, rowsPerPage, page) => {
    return Axios({
        method: 'POST',
        headers,
        data: { searchSchedule, rowsPerPage, page },
        url: `${endpointURL}/api/schedule/get-schedule`
    })
}

const CreateNewSchedule = async (scheduleInfor) => {
    return Axios({
        method: 'POST',
        headers,
        data: { scheduleInfor },
        url: `${endpointURL}/api/schedule/create-new-schedule`
    })
}

const UpdateSchedule = async (scheduleInfor) => {
    return Axios({
        method: 'POST',
        headers,
        data: { scheduleInfor },
        url: `${endpointURL}/api/schedule/update-schedule`
    })
}

const DisableSchedule = async (selected) => {
    return Axios({
        method: 'POST',
        headers,
        data: { selected },
        url: `${endpointURL}/api/schedule/disable-schedule`
    })
}
const EnableSchedule = async (selected) => {
    return Axios({
        method: 'POST',
        headers,
        data: { selected },
        url: `${endpointURL}/api/schedule/enable-schedule`
    })
}
const DeleteSchedule = async (selected) => {
    return Axios({
        method: 'POST',
        headers,
        data: { selected },
        url: `${endpointURL}/api/schedule/delete-schedule`
    })
}
const RunSchedule = async (scheduleID) => {
    return Axios({
        method: 'POST',
        headers,
        data: { scheduleID },
        url: `${endpointURL}/api/schedule/run-schedule`
    })
}
const KillSchedule = async (selected) => {
    return Axios({
        method: 'POST',
        headers,
        data: { selected },
        url: `${endpointURL}/api/schedule/kill-schedule`
    })
}
const GetHistories = async (scheduleID) => {
    return Axios({
        method: 'POST',
        headers,
        data: { scheduleID },
        url: `${endpointURL}/api/schedule/get-histories`
    })
}
const GetHistoriesDetails = async (historiesID, rowsPerPage, page) => {
    return Axios({
        method: 'POST',
        headers,
        data: { historiesID, rowsPerPage, page },
        url: `${endpointURL}/api/schedule/get-histories-details`
    })
}
export {
    GetSchedules,
    CreateNewSchedule,
    UpdateSchedule,
    DisableSchedule,
    EnableSchedule,
    DeleteSchedule,
    RunSchedule,
    KillSchedule,
    GetHistories,
    GetHistoriesDetails,
};
